// Firestore listeners for Marketing Hub (links, clicks, attributed events).
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";
import { db } from "./firebase";

export function watchMarketingLinks(onNext, onError) {
  const q = query(collection(db, "marketing_links"), orderBy("created_at", "desc"), limit(400));
  return onSnapshot(
    q,
    (snap) => {
      onNext(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    },
    onError || (() => {})
  );
}

export function watchClicksForLink(linkId, onNext, onError) {
  if (!linkId) return () => {};
  const q = query(
    collection(db, "marketing_click_events"),
    where("link_id", "==", linkId),
    orderBy("timestamp", "desc"),
    limit(2500)
  );
  return onSnapshot(
    q,
    (snap) => onNext(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    onError || (() => {})
  );
}

export function watchUserEventsForLink(linkId, onNext, onError) {
  if (!linkId) return () => {};
  const q = query(
    collection(db, "user_events"),
    where("link_id", "==", linkId),
    orderBy("timestamp", "desc"),
    limit(500)
  );
  return onSnapshot(
    q,
    (snap) => onNext(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    onError || (() => {})
  );
}
